export default ({request}) => ({
  ecomAmzFbaShipmentListApi(data = {}) {
    return request({
      url: '/ecom/amz/fba/shipment/list',
      method: 'POST',
      data,
    })
  },
  ecomAmzFbaShipmentDetailApi(data = {}) {
    return request({
      url: '/ecom/amz/fba/shipment/detail',
      method: 'POST',
      data,
    })
  },
  ecomAmzFbaShipmentDetailListApi(data = {}) {
    return request({
      url: '/ecom/amz/fba/shipment/detail/list',
      method: 'POST',
      data,
    })
  },
})
